import { URL_ACCOUNT_INVOICING_PAYABLE } from '@seek/adv-constants';
import {
  EMPLOYER_CONTACT_US_URL,
  FINANCE_PHONE_NUMBER,
} from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Alert, ContentBlock, Text, TextLink } from 'braid-design-system';
import type React from 'react';
import { useAppContext } from 'src/App/context/AppContext';
import translations from './.vocab';
import { useMelwaysLink } from '@seek/melways-react';
import type { Language } from '@seek/melways-sites';

const CreditHoldAlert: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { site, language } = useAppContext();
  const { t } = useTranslations(translations);
  const localize = useMelwaysLink();

  const isAnzSite = (
    siteName: string,
  ): siteName is keyof typeof FINANCE_PHONE_NUMBER =>
    Object.keys(FINANCE_PHONE_NUMBER).includes(siteName);

  if (isAnzSite(site)) {
    const contactNumber = FINANCE_PHONE_NUMBER[site];

    return (
      <ContentBlock>
        <Alert tone="caution" data-testid="credit-hold-phone">
          <Text>
            {t('You need to pay overdue invoices... ANZ', {
              PayInvoicesLink: (children) => (
                <TextLink
                  href={localize({
                    path: URL_ACCOUNT_INVOICING_PAYABLE,
                    language: language as Language,
                  })}
                >
                  {children}
                </TextLink>
              ),
              contactNumber,
            })}
          </Text>
        </Alert>
      </ContentBlock>
    );
  }

  return (
    <ContentBlock>
      <Alert tone="caution" data-testid="credit-hold-link">
        <Text>
          {' '}
          {t('You need to pay overdue invoices... Asia', {
            PayInvoicesLink: (children) => (
              <TextLink
                href={localize({
                  path: URL_ACCOUNT_INVOICING_PAYABLE,
                  language: language as Language,
                })}
              >
                {children}
              </TextLink>
            ),
            ContactUsLink: (children) => (
              <TextLink
                href={localize({
                  path: EMPLOYER_CONTACT_US_URL[site],
                  language: language as Language,
                })}
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Alert>
    </ContentBlock>
  );
};

export { CreditHoldAlert };
